;(function() {
  'use strict'

  Controller.$inject = ["$scope", "$state", "$stateParams", "$location", "AUTH_EVENTS", "glAnalytics", "glError", "userService", "communityService"];
  angular.module('app.intent').controller('Intent', Controller)

  /* @ngInject */
  function Controller(
    $scope,
    $state,
    $stateParams,
    $location,
    AUTH_EVENTS,
    glAnalytics,
    glError,
    userService,
    communityService
  ) {
    var Intents = [
      {
        type: 'view-messages',
        actionMethod: viewMessagesIntent,
        secureTitle: 'Secure Your Messages',
        secureText: 'Please set a password to access your Messages',
      },
      {
        type: 'join-crowd',
        actionMethod: joinCrowdIntent,
        actionIdRequired: true,
      },
      {
        type: 'view-profile',
        actionMethod: viewProfileIntent,
      },
    ]

    var States = ($scope.States = {
      IDLE: 'idle',
      LOADING: 'loading',
      SET_PASSWORD: 'secure',
      USERNAME: 'username',
    })

    $scope.$on(AUTH_EVENTS.loginSuccess, onLogin)

    $scope.currentUser = userService.get()
    $scope.intent = getIntent()

    $scope.formData = {
      email: $stateParams.email,
    }

    $scope.submitForm = submitForm
    $scope.performIntent = performIntent

    activate()

    function activate() {
      var isLoggedIn = userService.loggedIn()

      $scope.state = States.LOADING

      // check we have everything we need to continue...
      if (!haveRequiredDetails()) {
        var reason = 'incorrect url: ' + $location.url()
        return cancelIntent(reason)
      }

      // track intention
      track('LandedWithType', $scope.intent.type)
      if ($scope.intent.actionId) {
        track('LandedWithID', $scope.intent.actionId)
      }

      // if we are logged in as the correct user, route them to their destination
      if (isLoggedIn && $scope.currentUser.email === $scope.intent.email) {
        track('AlreadyLoggedIn', $scope.intent.email)
        return performIntent()
      }

      // if we are logged in but as the wrong user, logout
      if (isLoggedIn && $scope.currentUser.email !== $scope.intent.email) {
        userService.logout()
      }

      // figure out what kind of user we are dealing with
      userService.getRolesByEmail($scope.intent.email).then(
        function(roles) {
          var hasEmailRole = _.includes(roles, userService.Roles.EMAIL)
          var hasPhoneRole = _.includes(roles, userService.Roles.PHONE)

          // email users need to set a password
          if (hasEmailRole) {
            track('Prompted', $scope.intent.email)
            $scope.state = States.SET_PASSWORD
            return
          }

          // phone users need to log in
          if (hasPhoneRole) {
            track('AskedToLogin', $scope.intent.email)
            $scope.state = States.IDLE
            var data = {
              prefillEmail: $scope.intent.email,
              hideSignup: true,
            }
            return userService
              .showLogin(null, data)
              .then(onLogin, onLoginCancelled)
          }
        },
        function(data) {
          var reason = 'error getting roles @ ' + $location.url()
          track('Error', reason)
          glError.fromStatus(data)
        }
      )
    }

    function getIntent() {
      var intent = _.find(Intents, { type: $stateParams.type })
      if (!intent) {
        return
      }

      intent.actionId = $stateParams.id
      intent.email = $stateParams.email

      if (intent.actionIdRequired && !intent.actionId) {
        return
      }

      return intent
    }

    function haveRequiredDetails() {
      // ensure we have an intent and a user email
      return $scope.intent && $scope.intent.email
    }

    function onLogin() {
      // if user logged in with correct email - redirect to intent
      if ($scope.currentUser.email === $scope.intent.email) {
        return performIntent()
      }

      // otherwise abort intent - redirect to home
      if ($scope.currentUser.email !== $scope.intent.email) {
        var reason =
          'intent for ' +
          $scope.intent.email +
          ' but user logged in as ' +
          $scope.currentUser.email
        return cancelIntent(reason)
      }
    }

    function onLoginCancelled() {
      var reason =
        'user asked to login but closed login dialog: ' + $scope.intent.email
      cancelIntent(reason)
    }

    function cancelIntent(reason) {
      track('Error', reason)
      $state.go('app.public')
    }

    function performIntent() {
      $scope.intent.actionMethod()
    }

    function submitForm() {
      $scope.formData.error = false
      $scope.formData.isSaving = true

      userService.signup($scope.formData, true).then(
        function() {
          track('SetAPassword', $scope.intent.email)
          $scope.formData.isSaving = false
          $scope.state = States.USERNAME
        },
        function() {
          track('Error', 'couldnt set user password')
          $scope.formData.isSaving = false
          $scope.formData.error = true
        }
      )
    }

    function viewMessagesIntent() {
      track('ReachedIntent', $scope.intent.type)
      $state.go('app.portal.messageList', null, { location: 'replace' })
    }

    function viewProfileIntent() {
      track('ReachedIntent', $scope.intent.type)
      $state.go('app.portal.profile', null, { location: 'replace' })
    }

    function joinCrowdIntent() {
      var elementId = $scope.intent.actionId
      var crowd = communityService.get(elementId)

      $scope.state = States.LOADING

      crowd.join().then(
        function() {
          track('ReachedIntent', $scope.intent.type)
          $state.go('app.portal.communities', null, { location: 'replace' })
        },
        function() {
          var reason = 'join crowd request failed @ ' + $location.url()
          track('Error', reason)
          glError.internal()
        }
      )
    }

    function track(action, value) {
      glAnalytics.track('Intent', action, value)
    }
  }
})()
